import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const mkpStaticData = {
  menuTitle: MenuTitle.Marketplace
};
export const Route = createFileRoute('/_private-routes/marketplace/')({
  staticData: mkpStaticData
});
